import client from '../utils/client';
import env from '../env';

export const returnToAdminAccount = async (): Promise<boolean> => {
    try {
        const response = await client.post(`${env.apiUrl}/api/auth/login`, {});
        const data = response && response.data;

        if (!data || !data.accessToken) {
            return false;
        }

        localStorage.setItem('token', data.accessToken);

        if (data.refreshToken) {
            localStorage.setItem('refreshToken', data.refreshToken);
        }

        return true;
    }
    catch {
        return false;
    }
}
